import { render, staticRenderFns } from "./UserPreferences.vue?vue&type=template&id=ccd55070"
import script from "./UserPreferences.vue?vue&type=script&lang=js"
export * from "./UserPreferences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports